module.exports = __webpack_public_path__ + "img/cartier.c8be3c6f.jpg";